import { useCallback } from 'react';

import { useSettings } from '@modules/Settings/hooks/useSettings';

export const useLeaveReview = () => {
  const { settings } = useSettings();

  return useCallback(() => {
    const url = settings?.FEEDBACK_URL;
    if (!url) return;
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    const win = window.open(url, '_blank', 'noopener,noreferrer');
    if (win) {
      win.opener = null;
    }
  }, [settings]);
};
